import { helpIcon } from "assets/icons";
import { Button, Input, Select, TextArea } from "components/form";
import React, { useEffect, useState } from "react";
import "./Support.scss";
import { removeErrorFields, validateInput } from "validation";
import { support } from "validation/schema/support";
import {
  createSupportTicketApi,
  getReferenceNumberApi,
} from "services/support";
import { getFromLocal } from "config/axiosInstance";
import { toastMessage } from "utils/toastMessageHelper";
import useButtonLoader from "hooks/useButtonLoader";
import { useTranslation } from "react-i18next";
const Support = () => {
  // Set all value
  const [error, setError] = useState({});
  const [inputData, setInputData] = useState({});
  const [referenceNumberList, setReferenceNumberList] = useState([]);
  const { t } = useTranslation();

  // Hook
  const [sendButtonLoader, setSendButtonLoader] = useButtonLoader(
    t("SUPPORT.send")
  );

  // change input handler
  const changeHandler = (event) => {
    const { name, value } = event.target;
    setInputData({ ...inputData, [name]: value });
    setError((prevError) => removeErrorFields(prevError, name));
  };

  // Validate Input Data
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "createSupportTicketSchema",
      support,
      null
    );
    setError(errors);
    return status;
  };

  // Handle clear data
  const clearData = () => {
    setInputData({ title: "", message: "", referenceNumber: "" });
    setError({});
  };

  // get reference number handler
  const fetchReferenceNumberList = async () => {
    try {
      const reqData = {
        token: getFromLocal("token"),
      };

      const data = await getReferenceNumberApi(reqData);
      if (data?.status === 200) {
        setReferenceNumberList(data?.data?.loginResearcherSurveyList);
      } else {
        toastMessage(data?.message, "error", "userCreateSupportTicket");
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Create Support Ticekt Handler
  const createSupportTicketHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setSendButtonLoader(true);
        const reqData = {
          ...inputData,
          supportType: "help",
          token: getFromLocal("token"),
        };
        const responseData = await createSupportTicketApi(reqData);
        const { message = "", status } = responseData;
        if (status === 200) {
          clearData();
          toastMessage(message, "success", "userCreateSupportTicket");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setSendButtonLoader(false);
      }
    }
  };

  useEffect(() => {
    fetchReferenceNumberList();

    // eslint-disabled-next-line
  }, []);

  return (
    <>
      <div className="supports_page">
        <div className="content_section">
          <h3 className="dashboard_title">{t("SUPPORT.supportContact")}</h3>
          <p>{t("SUPPORT.supportContactDescription")}</p>
        </div>
        <div className="form_section">
          <form>
            <h4>
              <img src={helpIcon} alt="" />
              {t("SUPPORT.contactSupport")}
            </h4>
            <p>{t("SUPPORT.contactSupportDescription")}</p>
            <div className="form_field">
              <Select
                name="referenceNumber"
                label={t("SUPPORT.referenceNumber")}
                onChange={changeHandler}
                value={inputData?.referenceNumber}
                placeholder={t("SUPPORT.selectReferenceNumber")}
              >
                <option value={""}>{t("SUPPORT.select")}</option>
                {referenceNumberList?.length > 0 &&
                  referenceNumberList?.map((el) => (
                    <option key={el?._id} value={el?._id}>
                      {el?.surveyReferenceNumber}
                    </option>
                  ))}
              </Select>
            </div>
            <div className="form_field">
              <Input
                type="text"
                name="title"
                label={t("SUPPORT.title")}
                value={inputData?.title}
                placeholder={t("SUPPORT.enterTitle")}
                onChange={changeHandler}
              />
            </div>
            <div className="form_field">
              <TextArea
                placeholder={t("SUPPORT.enterMessage")}
                label={t("SUPPORT.enterMessage")}
                name="message"
                style={{ resize: "none" }}
                value={inputData?.message}
                onChange={changeHandler}
                error={error?.message}
                maxLength={200}
              />
            </div>
            <div className="button_wrap">
              <Button
                className={"w-100"}
                onClick={createSupportTicketHandler}
                ref={sendButtonLoader}
              >
                {t("SUPPORT.send")}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Support;
